module.exports = __webpack_public_path__ + "static/media/image2.e01115ab.png";